



































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapState } from 'vuex'
import { setThemeConfigs } from '@/utils/gamblingHelpers'
import Amounts from '@/components/gambling/Amounts'
import Cashier from '@/components/Cashier'
import Receipt from '@/components/Receipt'
import { StepObjCtx } from '@/utils/interfaces'

@Component({
  components: {
    Cashier,
    Receipt,
    Amounts
  },
  computed: {
    ...mapState({
      methodConfigState: ({ cashierContext }: any) => cashierContext.config.method,
      config: ({ cashierContext }: any): string => cashierContext.config,
      checkoutClient: ({ cashierContext }: any): string => cashierContext.checkoutClient
    })
  }
})
export default class Banking extends Vue {
  @Action('setTheme') setTheme: any
  @Action('reloadCashier') reloadCashier: any

  step: number = 1
  methodConfigState!: string
  checkoutTheme!: string
  config!: any
  $cashierConfigs!: any
  $smallScreen: any
  checkoutClient!: boolean
  stepsNotClickable: string[] = [ 'Details', 'Receipt' ]

  @Watch('methodConfig')
  onMethodConfig (method: string) {
    this.step = 1
    this.setMethod(method)
  }

  get methodConfig (): string {
    return this.methodConfigState
  }
  set methodConfig (method: string) {
    this.reloadCashier({
      method
    })
  }

  get getSteps (): StepObjCtx[] {
    const allSteps = [
      {
        title: 'Amount',
        step: 0
      },
      {
        title: 'Customer',
        step: 0
      },
      {
        title: 'Provider',
        step: 0
      },
      {
        title: 'Details',
        step: 0
      },
      {
        title: 'Receipt',
        step: 0
      }
    ]
    return allSteps.filter((step) => {
      if (this.checkoutClient) {
        return step
      } else {
        return step.title !== 'Customer'
      }
    }).map((val, i) => {
      val.step = (i + 1)
      return val
    })
  }


  get spinnerColor () {
    return this.checkoutTheme === 'light' ? 'secondary--text' : 'white--text'
  }

  cashierCallback (type: string) {
    switch (type) {
      case 'cashierDoneLoading':
        if (this.step === 2 && this.checkoutClient) {
          const providerStep: StepObjCtx = this.getSteps.find((step) => step.title === 'Provider') || this.getSteps[2]
          this.step = 3
        }
        break
      case 'reloadCashier':
        this.step = 1
        break
      default:
        break
    }
  }

  stepClick (stepObj: StepObjCtx) {
    const { step } = stepObj
    if (step === 1) {
      this.step = step
    } else if (step === 2) {
      const submitBtn: any = document.querySelector('#submit-btn')
      submitBtn && submitBtn.click()
    }
  }

  nextStep (amount: number) {
    this.$cashierConfigs('bankingPageFlow', {
      amount,
      showHeader: !this.$smallScreen
    })
    this.step = 2
  }
  setMethod (method = 'deposit') {
    this.$cashierConfigs('bankingPageFlow', {
      method,
      showHeader: !this.$smallScreen
    })
  }

  bankingCashierCallbacks (e: MessageEvent) {
    const { checkoutClient } = this
    if (e.data.eventType === 'APP_ROUTE_CHANGE') {
      switch (e.data.payload.path) {
        case '/amount':
          this.step = 1
          break
        case '/':
          this.step = 2
          break
        case '/payment-method':
          checkoutClient ? this.step = 4 : this.step = 3
          break
        case '/receipt':
          checkoutClient ? this.step = 5 : this.step = 4
          break
        default:
        break
      }
    }
  }

  created () {
    this.step = 1
    this.$cashierConfigs('bankingPageFlow', { showHeader: !this.$smallScreen })
    window.removeEventListener('message', this.bankingCashierCallbacks, false)
    window.addEventListener('message', this.bankingCashierCallbacks)
    const setCheckoutTheme = (theme: string) => this.checkoutTheme = theme
    setThemeConfigs(this.setTheme, setCheckoutTheme)
  }
}
